import scrollama from "scrollama";

import * as d3 from "d3";

import { hydrate } from "@propublica/pp-svelte/util/hydrate-baker.mjs";
import enhanceShortenedTables from "@propublica/pp-v5-shared/src/js/table.shortened.js";

import * as componentClasses from "./svelte-components.js";

import Glide from "@glidejs/glide";

// @ts-ignore (TODO(@alecglassford): Fix type problems with componentClasses)
hydrate(componentClasses);
enhanceShortenedTables();

// Add your code here! (or write other JS modules and use their imports here)
// TODO: do stuff with scroller

// javascript for triptych 1 and 2
document.addEventListener("DOMContentLoaded", function () {
    var highlightFunctions = {};

    const scrollys = document.querySelectorAll(".triptych");

    scrollys.forEach(function (item, index) {
        var scrollyNum = index + 1;

        var scrolly = d3.select("#triptych-" + scrollyNum + "");
        var figure = scrolly.select("figure");
        var trigger = scrolly.select("#steps");
        var step = trigger.selectAll(".step");
        var scroller = scrollama();
        const scrollySteps = item.querySelectorAll(".stepTrigger .step");

        var captions = [
            [
                {
                    activeWordId: 0,
                    caption: 1,
                    barId: 1,
                    barNum: 1,
                    element: document.getElementById("our-1t1-video"),
                    interval: undefined,
                    // prettier-ignore
                    json:
                  [{"start":0.00,"end":2,"id":0},
                  {"start":3,"end":5,"id":1},
                  {"start":5.2,"end":7.09,"id":2},
                  {"start":8,"end":11,"id":3}],
                },
                {
                    activeWordId: 0,
                    caption: 2,
                    barId: 2,
                    barNum: 2,
                    element: document.getElementById("our-2t1-video"),
                    interval: undefined,
                    // prettier-ignore
                    json:
                       [{"start":0,"end":1.17,"id":0},
                      {"start":1.2,"end":3,"id":1},
                      {"start":3.1,"end":4,"id":2},
                      {"start":4.1,"end":6,"id":3},
                      {"start":6.1,"end":9,"id":4},
                      {"start":9,"end":12,"id":5},
                      {"start":12.08,"end":15.12,"id":6}],
                },

                {
                    activeWordId: 0,
                    caption: 3,
                    barId: 3,
                    barNum: 3,
                    element: document.getElementById("our-3t1-video"),
                    interval: undefined,
                    // prettier-ignore
                    json:

                    [{"start":0,"end":1.24,"id":0},
                    {"start":2,"end":4,"id":1},
                    {"start":4,"end":6.08,"id":2}],
                },
            ],
            [
                {
                    activeWordId: 0,
                    caption: 1,
                    barId: 4,
                    barNum: 1,
                    element: document.getElementById("our-1t2-video"),
                    interval: undefined,
                    // prettier-ignore
                    json:
                  [{"start":0.01,"end":3.15,"id":0},
                   {"start":3.15,"end":5,"id":1},
                   {"start":5,"end":6,"id":2},
                   {"start":6,"end":6.2,"id":3},
                   {"start":7,"end":9,"id":4}],
                },
                {
                    activeWordId: 0,
                    caption: 2,
                    barId: 5,
                    barNum: 2,
                    element: document.getElementById("our-2t2-video"),
                    interval: undefined,
                    // prettier-ignore
                    json:
                      [{"start":1,"end":2.15,"id":0},
                       {"start":2.15,"end":3.15,"id":1},
                       {"start":3.18,"end":5,"id":2},
                       {"start":5,"end":6,"id":3},
                       {"start":6,"end":8,"id":4}],
                },
                {
                    activeWordId: 0,
                    caption: 3,
                    barId: 6,
                    barNum: 3,
                    element: document.getElementById("our-3t2-video"),
                    interval: undefined,
                    // prettier-ignore
                    json:
                    [{"start":0.01,"end":3.15,"id":0},
                    {"start":3.15,"end":7,"id":1}],
                },
            ],
        ];

        var state = captions[index][0];
        var thisVideoNum;

        getVideoUrls();

        function handleResize() {
            scroller.resize;
            const stickyItems = document.querySelectorAll(".sticky-item");
            let wh = window.innerHeight;

            stickyItems.forEach(function (stickyItem) {
                let hHeight = stickyItem.clientHeight;
                let hTop = (wh - hHeight) / 2;

                stickyItem.style.top = Math.max(hTop, 57) + "px";
            });

            getVideoUrls();

            if (window.innerWidth >= 750) {
                document
                    .querySelectorAll(".mobile-container-inside")
                    .forEach(function (item) {
                        item.style.marginLeft = "0";
                    });
            }
        }

        handleResize();
        window.addEventListener("resize", handleResize);

        // select which video is being triggered

        function getVideoUrls() {
            d3.selectAll("#triptych-" + scrollyNum + "video").each(function (
                v,
                i
            ) {
                var thisVideo = d3.select(this);
                var thisVideoNum = i + 1;
                var url =
                    "https://static.propublica.org/projects/graphics/2023-school-boards/videos/t" +
                    scrollyNum +
                    "-video" +
                    thisVideoNum +
                    ".mp4";
                thisVideo.select("source").attr("src", url);
                document
                    .getElementById(
                        "our-" + thisVideoNum + "t" + scrollyNum + "-video"
                    )
                    .load();
            });
        }

        // set up functions for StepEnter and StepExit

        function handleStepEnter(response) {
            // set up variables
            var thisVideoNum = response.index + 1;
            var thisStep = response.index;
            var theCaption = document.getElementById(
                "t" + scrollyNum + "-" + thisVideoNum + "-caption"
            );
            var activeVideo = document.getElementById(
                "t" + scrollyNum + "-v" + thisVideoNum + "-container"
            );
            var videoPlaying = document.getElementById(
                "our-" + thisVideoNum + "t" + scrollyNum + "-video"
            );

            // play video based on step
            document
                .getElementById(
                    "our-" + thisVideoNum + "t" + scrollyNum + "-video"
                )
                .play();

            // make video visible
            activeVideo.classList.remove("invisible");
            activeVideo.style.opacity = "1";

            var activeProgressBar = document.getElementById(
                "t" + scrollyNum + "-bar" + thisVideoNum + "-wrapper"
            );
            activeProgressBar.classList.add("activeBarText");

            var activeBar = document.getElementById(
                "t" + scrollyNum + "-v" + thisVideoNum + "-bar"
            );
            activeBar.classList.add("activeBar");

            theCaption.classList.add("visible");

            //set up state
            state = captions[index][thisStep];
            state.id = thisVideoNum + "t" + scrollyNum;

            //select the video that is playing
            var videoPlaying = document.getElementById(
                "our-" + thisVideoNum + "t" + scrollyNum + "-video"
            );
            // console.log(videoPlaying);

            // create mobile behavior
            var activeContainer = document.getElementById(
                "mobile-container-" + scrollyNum + "-inside"
            );

            if (window.innerWidth < 750) {
                if (thisVideoNum === 1) {
                    activeContainer.style.marginLeft = "0%";
                }

                if (thisVideoNum === 2) {
                    activeContainer.style.marginLeft = "-50%";
                }

                if (thisVideoNum === 3) {
                    activeContainer.style.marginLeft = "-100%";
                }
            } else {
                activeContainer.style.marginLeft = "0%;";
            }

            // run the other functions
            firstMuteVideos();
            secondMuteVideos();
            registerEvents();
        }

        function handleStepExit(response) {
            var thisVideoNum = response.index + 1;
            var activeVideo = document.getElementById(
                "t" + scrollyNum + "-v" + thisVideoNum + "-container"
            );
            var videoPlaying = document.getElementById(
                "our-" + thisVideoNum + "t" + scrollyNum + "-video"
            );

            videoPlaying.pause();

            activeVideo.style.opacity = ".3";
            activeVideo.style.transition = "opacity 1s ease";

            // remove active progress bar

            var activeProgressBar = document.getElementById(
                "t" + scrollyNum + "-bar" + thisVideoNum + "-wrapper"
            );

            activeProgressBar.classList.remove("activeBarText");

            var activeBar = document.getElementById(
                "t" + scrollyNum + "-v" + thisVideoNum + "-bar"
            );
            activeBar.classList.remove("activeBar");

            // handle captions
            var theCaption = document.getElementById(
                "t" + scrollyNum + "-" + thisVideoNum + "-caption"
            );
            theCaption.classList.remove("visible");

            unhighlightAllWords();
        }

        // set up mute button for first triptych

        function firstMuteVideos() {
            var firstButton = document.getElementById("first-mutebtn");
            const firstVideos = document.querySelectorAll(".t1videos");
            var muteToggle = document.getElementById("first-mutetoggle");
            var svgMuted = document.getElementById("first-svg-muted");
            var svgOn = document.getElementById("first-svg-on");

            firstButton.onclick = function () {
                firstVideos.forEach(function (video, i) {
                    if (video.muted === false) {
                        video.muted = true;
                    } else {
                        video.muted = false;
                    }
                });
                if (muteToggle.innerHTML === "Muted") {
                    muteToggle.innerHTML = "";
                    muteToggle.style.marginRight = "0em";
                    svgMuted.classList.add("display-none");
                    svgOn.classList.remove("display-none");
                } else {
                    muteToggle.innerHTML = "Muted";
                    muteToggle.style.marginRight = "1em";
                    svgMuted.classList.remove("display-none");
                    svgOn.classList.add("display-none");
                }
            };
        }

        function secondMuteVideos() {
            var secondButton = document.getElementById("second-mutebtn");
            const secondVideos = document.querySelectorAll(".t2videos");
            var secondMuteToggle = document.getElementById("second-mutetoggle");
            var svgMuted2 = document.getElementById("second-svg-muted");
            var svgOn2 = document.getElementById("second-svg-on");

            secondButton.onclick = function () {
                secondVideos.forEach(function (video, i) {
                    if (video.muted === false) {
                        video.muted = true;
                    } else {
                        video.muted = false;
                    }
                });

                if (secondMuteToggle.innerHTML === "Muted") {
                    secondMuteToggle.innerHTML = "";
                    secondMuteToggle.style.marginRight = "0em";
                    svgMuted2.classList.add("display-none");
                    svgOn2.classList.remove("display-none");
                } else {
                    secondMuteToggle.innerHTML = "Muted";
                    secondMuteToggle.style.marginRight = "1em";
                    svgMuted2.classList.remove("display-none");
                    svgOn2.classList.add("display-none");
                }
            };
        }

        // set up saturation on pause

        // const tVideos = document.querySelectorAll(".video-overlay");
        // tVideos.forEach((video) => {
        //     video.addEventListener("play", () => {
        //         video.classList.remove("desaturated");
        //     });
        //     video.addEventListener("pause", () => {
        //         video.classList.add("desaturated");
        //     });
        // });

        // kick things off

        function init() {
            handleResize();
            scroller
                .setup({
                    step: scrollySteps,
                    offset: 0.8,
                    debug: false,
                })
                .onStepEnter(handleStepEnter)
                .onStepExit(handleStepExit);

            // setup resize event
            window.addEventListener("resize", handleResize);
        }

        // kick things off
        init();

        // set up caption reveal

        /**
         * Runs several times per second while audio is playing, to highlight current word
         */

        function highlightWord() {
            const currentTime = state.element.currentTime;
            var duration = state.element.duration;
            var durationEnd = Math.round(duration - currentTime);
            var durationPct = currentTime / duration;
            var currentWidth = durationPct * 60;
            // console.log(durationPct);
            // console.log(durationEnd)

            var activeProgress = document.getElementById(
                "bar" + state.barId + "-id"
            );

            function addLeadingZero(num, size) {
                var string = "00" + parseInt(num);
                return string.substr(string.length - 2);
            }

            /**
             * Adds a leading 0 before single digit numbers, to be used in a timestamp
             * @param {number} num The number to format,
             * @param {number} size How long should the number be (probably should be 2, to make sure 8 seconds shows up as 08)
             */

            // create timestamp
            activeProgress.innerHTML = `00:${addLeadingZero(durationEnd)}`;

            var currentBar = document.getElementById(
                "t" + scrollyNum + "-v" + state.barNum + "-bar"
            );
            currentBar.style.width = currentWidth + "px";

            let captionElement = document.querySelector(
                "#t" + scrollyNum + "-" + state.caption + "-caption"
            );

            // Get the current word (if there is one)
            const match = state.json.find(function (item) {
                return currentTime >= item.start && currentTime <= item.end;
            });
            // console.log("highlightWord","#t"+scrollyNum+"-"+state.caption+"-caption");

            if (match) {
                // Remove the .word-active class from the previously active word, which is now inactive
                const previousWord = captionElement.querySelector(
                    `[word-id="${state.activeWordId}"]`
                );
                previousWord.classList.remove("word-active");

                // Add the .word-active class to the newly active word
                const currentWord = captionElement.querySelector(
                    `[word-id="${match.id}"]`
                );
                currentWord.classList.add("word-active");

                // Record the id for the current word
                state.activeWordId = match.id;

                // Show matching word in console
                // console.table(match);
            }
        }

        function unhighlightAllWords() {
            // console.log("unhighlight");
            document.querySelectorAll(".word").forEach(function (word) {
                word.classList.remove("word-active");
            });

            state.activeWordId = 0;
        }

        /**
         * Register events for audio interactions (play, pause, etc.)
         */

        function registerEvents() {
            // console.log(state);

            if (!state.hasEvents) {
                state.element.addEventListener("play", function (e) {
                    // console.log("play");
                    // Run the highlightWord function every 50ms
                    state.interval = setInterval(highlightWord, 100);
                });

                state.element.addEventListener("pause", function (e) {
                    // console.log("pause",state.interval);
                    // Stop running the highlightWord function every 100ms
                    clearInterval(state.interval);
                });

                state.element.addEventListener("ended", function (e) {
                    // Stop running the highlightWord function every 100ms
                    // console.log("ended",state.interval);
                    clearInterval(state.interval);
                    const previousWord = document.querySelector(
                        `[word-id="${state.activeWordId}"]`
                    );
                    previousWord.classList.remove("word-active");
                });
            }
            state.hasEvents = true;
        }

        // end for each loop
    });
});

d3.select("#final-grid-scrolly .step-1").on("stepin", function (e) {
    d3.selectAll(".monroe,.brevard,.elpaso,.rochester,.mitchell")
        .classed("highlight-category", true)
        .classed("desaturated", false);

    document.querySelectorAll(".third-scrolly-video").forEach(function (item) {
        if (item.classList.contains("step1-pause")) {
            item.pause();
        } else {
            item.play();
        }
    });
});

d3.select("#final-grid-scrolly .step-1").on("stepout", function (e) {
    if (e.detail.direction === "up") {
        d3.selectAll(".monroe,.brevard,.elpaso,.rochester,.mitchell")
            .classed("desaturated", true)
            .classed("highlight-category", false);
        document
            .querySelectorAll(".third-scrolly-video")
            .forEach(function (item) {
                item.play();
            });
    }
});

d3.select("#final-grid-scrolly .step-2").on("stepin", function (e) {
    d3.selectAll(".mckinney,.wayne")
        .classed("highlight-category", true)
        .classed("desaturated", false);
    d3.selectAll(
        ".monroe,.brevard,.elpaso,.rochester,.mitchell,.winstonsalem,.roundrock"
    )
        .classed("highlight-category", false)
        .classed("desaturated", true);
    document.querySelectorAll(".third-scrolly-video").forEach(function (item) {
        if (item.classList.contains("step2-pause")) {
            item.pause();
        } else {
            item.play();
        }
    });
});

d3.select("#final-grid-scrolly .step-2").on("stepout", function (e) {
    d3.selectAll(".mckinney,.wayne")
        .classed("highlight-category", false)
        .classed("desaturated", true);
});

d3.select("#final-grid-scrolly .step-3").on("stepin", function (e) {
    d3.selectAll(".brevard,.rochester,.winstonsalem,.roundrock")
        .classed("highlight-category", true)
        .classed("desaturated", false);
    d3.selectAll(".mckinney,.wayne,.monroe")
        .classed("highlight-category", false)
        .classed("desaturated", true);

    document.querySelectorAll(".third-scrolly-video").forEach(function (item) {
        if (item.classList.contains("step3-pause")) {
            item.pause();
        } else {
            item.play();
        }
    });
});

d3.select("#final-grid-scrolly .step-3").on("stepout", function (e) {});

d3.select("#final-grid-scrolly .step-4").on("stepin", function (e) {
    d3.selectAll(".mckinney,.rochester,.roundrock")
        .classed("highlight-category", true)
        .classed("desaturated", false);
    d3.selectAll(".monroe,.brevard,.winstonsalem")
        .classed("highlight-category", false)
        .classed("desaturated", true);
    document.querySelectorAll(".third-scrolly-video").forEach(function (item) {
        if (item.classList.contains("step4-pause")) {
            item.pause();
        } else {
            item.play();
        }
    });
});

d3.select("#final-grid-scrolly .step-4").on("stepout", function (e) {
    if (e.detail.direction === "up") {
        d3.selectAll(".monroe,.mckinney")
            .classed("highlight-category", false)
            .classed("desaturated", true);
        d3.selectAll(".brevard,.rochester,.winstonsalem,.roundrock")
            .classed("highlight-category", true)
            .classed("desaturated", false);
    }
    if (e.detail.direction === "down") {
        d3.selectAll(".classVidControl")
            .classed("highlight-category", false)
            .classed("desaturated", true);
        document
            .querySelectorAll(".third-scrolly-video")
            .forEach(function (item) {
                item.pause();
            });
    }
});

// document.addEventListener("DOMContentLoaded", function() {

// run resize only when content is fully loaded:

window.addEventListener("load", function () {
    finalHandleResize();
    window.addEventListener("resize", finalHandleResize);
    finalInit();
});

// initialize scrollama

function finalHandleResize() {
    // finalScroller.resize;

    const finalStickyItem = document.querySelector("#third-sticky-item");
    let winHeight = window.innerHeight;

    let hItemHeight = finalStickyItem.clientHeight;

    let heightTop = (winHeight - hItemHeight) / 2;

    finalStickyItem.style.top = Math.max(heightTop, 57) + "px";
}

const finalScrolly = document.querySelector("#final-grid-scrolly");
const finalScrollySteps = finalScrolly.querySelectorAll(".scrolly-text .step");
const finalScroller = scrollama();

function finalInit() {
    finalHandleResize();
    finalScroller
        .setup({
            step: finalScrollySteps,
            offset: 0.8,
        })
        .onStepEnter(handleStepEnter)
        .onStepExit(handleStepExit);

    function handleStepEnter(response) {
        const event = new CustomEvent("stepin", {
            detail: { direction: response.direction },
        });
        response.element.dispatchEvent(event);
    }
    function handleStepExit(response) {
        const event = new CustomEvent("stepout", {
            detail: { direction: response.direction },
        });
        response.element.dispatchEvent(event);
    }

    window.addEventListener("resize", finalHandleResize);
}

/* SWIPE CAROUSEL*/

const mediaQuery = window.matchMedia("(max-width:60em)");
let Slider = new Glide(".glide", {
    type: "slider",
    startAt: 0,
    perView: 1.2,
    animationDuration: 0,
    gap: 20,
    swipeThreshold: 10,
    dragThreshold: 120,
    animationDuration: 600,
});

mediaQuery.addEventListener("change", () => {
    if (mediaQuery.matches) {
        Slider.mount();

        const ArrowRight = document.querySelector(".glide__arrow--right");
        ArrowRight.addEventListener("click", () => {
            Slider.go(">");
        });

        const Arrowleft = document.querySelector(".glide__arrow--left");
        Arrowleft.addEventListener("click", () => {
            Slider.go("<");
        });

        const Slides = document.querySelector(".glide__slides");
        ArrowRight.addEventListener("click", () => {
            Slider.go(">");
        });
    } else {
        Slider.destroy();
    }
});
